const cloneObject = (obj) => JSON.parse(JSON.stringify(obj));

class BaseChart {
  constructor({ chartConfigurationElementId, chartContainerId }) {
    this.isDataTableInitialized = false;
    this.desktopMinWidth = 768;
    this.chartContainerId = chartContainerId;
    this.chartConfiguration = JSON.parse(document.getElementById(chartConfigurationElementId).innerText);
    this.baseOptions = {
      legend: {
        position: 'none',
      },
      fontName: '"Montserrat", sans-serif',
      backgroundColor: 'transparent',
      colors: window.isHighContrastMode ? [
        '#ffffff', '#ffffff', '#ffffff',
      ] : [
        '#023d9b', '#6f83ff', '#0564fa',
      ],
    };
    this.mobileOptions = {};
    this.desktopOptions = {};
    this.dataTable = new google.visualization.DataTable();

    window.addEventListener('resize', () => this.draw(), true);

    this.chart = null;
  }

  draw() {
    this.initDataTable();
    this.chart.draw(this.dataTable, this.getOptionsForCurrentResolution());
  }

  initDataTable() {
    if (this.isDataTableInitialized)
      return;
    this.initColumns();
    this.dataTable.addRows(this.chartConfiguration['data']);
    this.isDataTableInitialized = true;
  }

  initColumns() {
  }

  getOptionsForCurrentResolution() {
    return document.documentElement.clientWidth > this.desktopMinWidth ? this.desktopOptions : this.mobileOptions;
  }
}

// Line charts
class LineGraph extends BaseChart {
  constructor(props) {
    super(props);
    const textColor = window.isHighContrastMode ? '#fff' : '#33394b';
    this.mobileOptions = cloneObject(this.baseOptions);
    this.mobileOptions.lineWidth = 3;
    this.mobileOptions.chartArea = {
      top: 8,
      left: 60,
      right: 0,
      height: 160
    };
    this.mobileOptions.vAxis = {
      baselineColor: '#cccccc',
      format: 'short',
      textPosition: 'out',
      textStyle: {
        color: textColor,
        fontSize: 10,
        bold: true,
      },
    };
    this.mobileOptions.hAxis = {
      textStyle: {
        color: textColor,
        fontSize: 10,
        bold: true,
      },
    };

    this.desktopOptions = cloneObject(this.mobileOptions);
    this.desktopOptions.vAxis.textStyle.fontSize = 12;
    this.desktopOptions.vAxis.format = 'currency';
    this.desktopOptions.hAxis.textStyle.fontSize = 13;
    this.desktopOptions.lineWidth = 4;
    this.desktopOptions.chartArea.left = 130;

    this.chart = new google.visualization.LineChart(document.getElementById(this.chartContainerId));
  }
}

export class ClientsIncomesLineGraph extends LineGraph {
  constructor() {
    super({
      chartConfigurationElementId: 'incomesByYearChart',
      chartContainerId: 'incomesChart'
    });
  }

  initColumns() {
    const { param1 } = this.chartConfiguration;
    this.dataTable.addColumn('string', 'Rok');
    this.dataTable.addColumn('number', 'Dochody (zł)');
    this.dataTable.addColumn('number', `${param1} (zł)`);
  }
}

export class NonClientsIncomesLineGraph extends ClientsIncomesLineGraph {
  initColumns() {
    this.dataTable.addColumn('string', 'Rok');
    this.dataTable.addColumn('number', 'Dochody (zł)');
  }
}

export class ClientsExpensesLineGraph extends LineGraph {
  constructor() {
    super({
      chartConfigurationElementId: 'expensesByYearChart',
      chartContainerId: 'expensesChart'
    });
  }

  initColumns() {
    this.dataTable.addColumn('string', 'Rok');
    this.dataTable.addColumn('number', 'Suma wydatków (zł)');
    this.dataTable.addColumn('number', 'Wydatki majątkowe (zł)');
  }
}

export class NonClientsExpensesLineGraph extends ClientsExpensesLineGraph {
  initColumns() {
    this.dataTable.addColumn('string', 'Rok');
    this.dataTable.addColumn('number', 'Suma wydatków (zł)');
  }
}
